import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_all_contact_submission } from '../../api/contactAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdEdit } from 'react-icons/md';
import notify from '../../utils/IANotification';
import { tidy_date } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable'
import Button from '../../components/ui/Button'

export default function ContactPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()
  const [contacts, setContacts] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchAllContact()
  }, [])

  const fetchAllContact = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_contact_submission()
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
    } else {
      setContacts(data?.reverse())
    }
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Name",
      accessor: "name"
    },
    {
      header: "Email",
      accessor: "email"
    },
    {
      header: "Contact Number",
      accessor: "contact_number"
    },
    {
      header: "Date Submitted",
      accessor: "createdAt",
      modifier: (data) => tidy_date(data)
    }
  ]

  return (
    <AdminLayout
      navSelected={"Contact Form"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Contact Form</h1>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        /> 
      </div>
      */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={contacts}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/contact/details?form_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
          {/* {contacts.map((data, index) => {
            if (!JSON.stringify(data).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10 cursor-pointer"
                onClick={() => {
                  navigate("/admin/contact/details?form_id=" + data.id)
                }}
              >
                <div className="w-100">
                  <div className="flex-row flex justify-between items-center w-100">
                    <h3>{data?.name}</h3>
                  </div>
                  <h3 className='gray card-subtitle'>{data?.email || data?.contact_number}</h3>
                  <p className='gray card-subtitle'>{tidy_date(data?.createdAt)}</p>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/contact/details?form_id=" + data.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
        </div>
      )}
    </AdminLayout>
  )
}
